import React from "react";

export default function SQLServer_DAY() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_DAY</h1>
      <p>This is the SQLServer_DAY component generated from the SQL JSON.</p>
    </div>
  );
}
